/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum QuestionVisualizationEnum {
    AverageRankForEach = 'AverageRankForEach',
    Histogram = 'Histogram',
    HorizontalBarGraphOfAverages = 'HorizontalBarGraphOfAverages',
    Average = 'Average',
    Distribution = 'Distribution',
    HorizontalHistogram = 'HorizontalHistogram',
    ListOfResponses = 'ListOfResponses',
    MatrixRow = 'MatrixRow',
    TextColumn = 'TextColumn',
    Matrix = 'Matrix',
    StackedBarChart = 'StackedBarChart',
    MultiSelectGrid = 'MultiSelectGrid',
    TextGrid = 'TextGrid',
    MaxDiff = 'MaxDiff'
}

